"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Form = require("./Form.Styled");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Form = _ref => {
  let {
    onSubmit,
    children,
    className
  } = _ref;

  const submit = e => {
    e.preventDefault();
    onSubmit();
  };

  if (typeof onSubmit !== 'function') return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Form.StyledForm, {
    onSubmit: submit,
    className: className
  }, children);
};

var _default = Form;
exports.default = _default;